import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

import { HeaderStateService } from '../../../main/headers/services/header-state.service';
import { SharedToasterService } from '../../../shared/services/shared-toaster.service';
import { AssignmentBillingPeriodDetailModel } from '../../models/assignment-billing-period-detail.model';
import { AssignmentsService } from '../../services/assignments.service';

@Component({
    templateUrl: './billed-assignments-period.component.html',
    styleUrl: './billed-assignments-period.component.scss'
})
export class BilledAssignmentsPeriodComponent implements OnInit {
    protected periodId!: number;
    protected periodDetail: AssignmentBillingPeriodDetailModel | null = null;

    constructor(
        private route: ActivatedRoute,
        private assignmentService: AssignmentsService,
        private headerStateService: HeaderStateService,
        private sharedToasterService: SharedToasterService,
        private translocoService: TranslocoService
    ) {
        this.setTitle('');
    }

    ngOnInit(): void {
        let periodId = this.route.snapshot.paramMap.get('id') || null;
        if (!periodId || Number.isNaN(periodId)) return;
        this.periodId = Number(periodId);

        this.loadBilldedAssignmentsForYear()
    }

    private setTitle(period: string): void {
        this.headerStateService.setDetailHeader(
            this.translocoService.translate('main.header.billedAssignmentsTitle'),
            period,
            '/assignments/billed'
        );
    }

    protected isAssignmentOnSameDay(from: Date | undefined, to: Date | undefined): boolean {
        if (!from || !to) return false;
        return new Date(from).toDateString() === new Date(to).toDateString();
    }

    private loadBilldedAssignmentsForYear(): void {

        this.assignmentService.getAssignmentBillingPeriodDetails(this.periodId)
            .subscribe({
                next: (response) => {
                    response.items = response.items.sort((a, b) => new Date(b.from).getTime() - new Date(a.from).getTime());
                    this.periodDetail = response;
                    this.setTitle(response.period);
                },
                error: (error) => {
                    this.sharedToasterService.showGeneralDataLoadingError();
                }
            });
    }
}
